export default {"src":"/_next/static/media/virgin-atlantic.46d31fcd.svg","height":42,"width":180,"blurWidth":0,"blurHeight":0};